import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const COMPONENT_RESOURCES = Resources.Components.MooneLitePopup;
const EXPIRATION_RESOURCES = Resources.Components.DocumentExpirationWarning;

export type MooneLiteCta = { link: string; text: string };

/**
 * The one call to action for a restricted account, shared by every surface that nags about it
 * (the dashboard popup, the chat payment menu): where to send the person depends on what is
 * missing, and the three branches must never drift apart.
 *
 * - An expired document: the person already completed onboarding, so the CTA sends them to upload
 *   the new document, not into a registration flow they would have nothing to do in.
 * - Identity KYC done, bank missing: the wizard cannot help, the bank connect is the last step.
 * - Otherwise: complete the registration.
 */
export const useMooneLiteCta = (): MooneLiteCta => {
  const { isDocExpired, isLiteBecauseOfBank } = useIsUserInMooneLite();
  const { t } = useResource();

  if (isDocExpired) {
    return {
      link: appUrl("user-account"),
      text: t(EXPIRATION_RESOURCES.UploadNewDocument),
    };
  }

  if (isLiteBecauseOfBank) {
    return {
      link: appUrl("banking-auth"),
      text: t(COMPONENT_RESOURCES.ConnectBankAccountButton),
    };
  }

  return {
    link: appUrl("complete-customer-onboarding"),
    text: t(COMPONENT_RESOURCES.CompleteRegistrationButton),
  };
};
